import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { ConfirmAlertDialog } from "../../../components/common/ConfirmAlertDialog";
import { Lists } from "../../../components/common/Lists";
import TableComponent from "../../../components/common/Tables";
import { useAppDispatch } from "../../../hooks/hooks";
import { useGetPhasesQuery } from "../../../hooks/scientific/useGetPhasesQuery";
import { routes } from "../../../routes";
import { PhaseType } from "../../../types/ScientificModule";
import { Key_phases } from "../../../utils/constants";
import { updatePhase } from "../../../services/scientific/phase";
import { setPhasesData } from "../../../redux/slices/scientific/phases";

const columnNamesMap: { [key: string]: string } = {
  description: 'Descrição',
  phasePrevious: 'Fase anterior',
  phaseNext: 'Fase Seguinte',
  // end: 'Fim',
};

export const Phases = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { data, status } = useGetPhasesQuery({ PageNumber: currentPage, PageSize: 400 });
  const [deleteItem, setDeleteItem] = useState<PhaseType | null>(null);
  const mutationUpdate = useMutation(updatePhase, {
    onSuccess: () => {
      queryClient.invalidateQueries(Key_phases);
      toast.success('Fase atualizada com sucesso');
    },
    onError: () => {
      toast.error("Erro ao atualizar Fase.");
    }
  });

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleClickCreate = () => {
    navigate(routes.createPhase);
  };

  const handleEdit = (c: PhaseType) => {
    dispatch(setPhasesData(c));
    navigate(routes.updatePhase);
  };

  const handleDelete = (c: PhaseType) => {
    c.status = false;
    mutationUpdate.mutateAsync(c);
  };

  const openDeleteDialog = (s: PhaseType) => {
    setDeleteItem(s);
  };

  const confirmDelete = async () => {
    if (deleteItem) {
      await handleDelete(deleteItem);
    }
  };

  const options = data?.items.map((c: PhaseType) => [
    {
      label: 'Editar',
      onClick: () => handleEdit(c),
      icon: <Pencil1Icon />
    },
    {
      label: 'Eliminar',
      onClick: () => openDeleteDialog(c),
      icon: <TrashIcon />
    }
  ]) || [];

  return (
    <>
      <Lists
        status={status}
        TableComponent={() =>
          <TableComponent
            columns={Object.keys(columnNamesMap)}
            items={data?.items}
            options={options}
            columnNamesMap={columnNamesMap}
            totalPages={data?.totalPages || 1}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            emptyMessage="Ainda não existem fases registadas."
          />
        }
        handleClickCreate={handleClickCreate}
      />
      <ConfirmAlertDialog
        open={!!deleteItem}
        onOpenChange={(open) => !open && setDeleteItem(null)}
        title="Esta operação é irreversível"
        description="A fase deixará de estar disponível. Pretende continuar?"
        confirmLabel="Eliminar"
        item={deleteItem}
        onConfirm={confirmDelete}
        onCancel={() => setDeleteItem(null)}
      />
    </>
  );
};
